<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';
import ModaFormPayComponent from '@/components/contracts/ModaFormPayComponent.vue';
import Pagination from 'vue-pagination-2';
import ModalFormComponentContracts from '@/components/contracts_new/ModaFormComponent.vue';

// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';

export default {
	name: "invoices-issued",
	components: {
		ModalFormComponentContracts,
		ModaFormPayComponent,
		Pagination
	},
	data() {
		return {
			loadAll: false,
			data: {},
			name: '',
			editTax: true,
			search: {
				building_id: '',
				department_id: '',
				user_id: '',
			},
			editPay: false,
			idConvert: '',
			idUser: '',
			page: 1,
			send: false,
			catalogue: new Catalogue(),
			load: false,
		}
	},
	async mounted() {
		this.loadAll = true;

		this.list();
		this.catalogue.get_buildings();
		this.catalogue.get_users_profile(7);
		this.loadAll = false;

	},
	created() {
		Event.$on("event-load-taxes", () => {
			this.list();
		});
	},
	methods: {
		showNewContracts(contract_id) {   
            Event.$emit('event-show-showContractID', contract_id);
        },		
		async formDataPaysFast(pay, check = {}, editPay = false) {
            this.editPay = editPay;
            Event.$emit('event-show-addPayContracts', pay, check, pay.rent);
        },
		getDepartments(){
			this.catalogue.get_departamens_buildings(this.search.building_id);
			this.department_id = '';
		},
		downloadDebt() {
			let params = new URLSearchParams(this.search).toString();
			window.open(this.globalUrlFiles + '/debt_report?' + params, '_blank');
		},
		async list() {
			this.load = true;
			let service = request;
			let params = new URLSearchParams(this.search).toString();
			let _endpoint = '/contract_invoices_issued?' + params;
			try {
				let { data } = await service.get(_endpoint)
				if (data) {
					this.data = data;
					this.load = false;

				}
			} catch (error) {
				console.log(error);
				this.load = false;

			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'search': {
			handler: function () {
				this.list();
			},
			deep: true
		}		
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<template>
	<div class="col-12">
		<ModalFormComponentContracts :prop_edit="false" />
        <ModaFormPayComponent :prop_edit="editPay" />
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Facturas emitidas</h3>
				<div class="card-tools">
					<!-- <button @click="downloadDebt()" class="btn btn-sm btn-outline-success">
						<i class="fa fa-file-excel"></i> Excel de adeudos
					</button> -->
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-4">
						<label>Propiedad :</label>
						<select v-model="search.building_id" @change="getDepartments"  class="form-control">
							<option value="">Todos</option>
							<option v-for="(company, index) in catalogue.buildings" :key="index"
								:value="company.id"> {{ company.name }}
							</option>
						</select>
					</div>
					<div class="col-md-4">
						<label>Indiviso :</label>
						<select class="form-control" v-model="search.department_id">
							<option value="">Todos</option>
							<option v-for="(department, index) in catalogue.departamens_buildings" :key="index" :value="department.id">
								{{ department.number }} / {{ department.level }}
							</option>
						</select>
					</div>
					<div class="col-md-4">
						<label>Arrendatario :</label>
						<select class="form-control" v-model="search.user_id">
							<option value="">Todos</option>
							<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}
							</option>
						</select>
					</div>
				</div>
				<br>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>Locales</th>
								<th>Arrendatario</th>
								<th>Vigencia</th>
								<th>Factura</th>
								<th>Servicio</th>
								<th>Monto</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="10">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>

								</td>
							</tr>
						</tbody>
						<tbody v-else-if="data.data.length > 0">
							<tr v-for="(val, index) in data.data" :key="index">
								<td>
									<div v-if="val.locales.length > 0">
										<span v-for="(locale, index) in val.locales" :key="index">
											# {{ locale.number }} - {{ locale.level }}
										</span>
									</div>
									<div v-else>Sin Local</div>
								</td>
								<td>
									{{ val.user }}
								</td>
								<td>
									{{ val.date | toDateTime }}
								</td>
								<td>
									<span v-if="val.external">
										Generada
									</span>
									<span v-else>
										Cargada
									</span>

								</td>
								<td>
									<span v-if="val.items.length > 0">
										<span v-for="(item, index) in val.items" :key="index">
											{{ item.name }}
											<hr v-if="index < val.items.length - 1">
										</span>
									</span>									
								</td>
								<td>
									{{ val.amount | toCurrency }}
								</td>
								<td>
									<button class="btn btn-sm btn-outline-success" @click="showNewContracts(val.id_contrato)">
										<i class="fa fa-eye"></i> <br> Ver contrato
									</button>
									<!-- <button v-if="val.pay" @click="formDataPaysFast(val.tenant, val.pay)" class="btn btn-outline-primary btn-sm m-1">  
                                        <i class="fa fa-eye"></i> <br> Ver pago
                                    </button>

									<button v-else @click="formDataPaysFast(val.tenant, {}, true)" class="btn btn-sm btn-outline-success">
										<i class="fa-solid fa-plus"></i> <br> Pagar
									</button>									  -->
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="9">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination v-model="page" :records="data.total" :per-page="data.per_page" @paginate="list" />
			</div>
		</div>

	</div>
</template>


<style scoped>
.pagination {
	margin-bottom: 0;
}
</style>
